import React, { useState } from 'react';
import styles from './CategoryManagement.module.scss';
import FilterTabsCommon from '../../../../components/common/FilterTabsCommon/FilterTabsCommon';
import { Container, TabContent, TabPane } from 'reactstrap';
import ExistingCategories from '../../../../components/WholesalerComponents/CategoryManagementTabs/ExistingCategories/ExistingCategories';
import CreateNewCategory from '../../../../components/WholesalerComponents/CategoryManagementTabs/CreateNewCategory/CreateNewCategory';

const fiterTabs = [
    { id: '1', label: 'Manage Existing Categories' },
    { id: '2', label: 'Create New Category' },
];

const CategoryManagement = () => {
    const [activeTab, setActiveTab] = useState('1');

    return (
        <div className={styles.mainContainer}>
            <h4 className={styles.sectionHeading}>Category Management</h4>
            <Container fluid className={styles.categoryManagementContainer}>
                <div className={styles.filterContainer}>
                    <FilterTabsCommon
                        tabs={fiterTabs}
                        activeTab={activeTab}
                        setActiveTab={setActiveTab}
                    />
                </div>

                <div>
                    <TabContent activeTab={activeTab}>
                        <TabPane tabId='1'>
                            <ExistingCategories />
                        </TabPane>
                        <TabPane tabId='2'>
                            <CreateNewCategory />
                        </TabPane>
                    </TabContent>
                </div>
            </Container>
        </div>
    );
};

export default CategoryManagement;